import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Translate } from 'react-localize-redux';

/**
 * SKIN-600 — the patient page's header in a dermatologist's web session, in place of the patient
 * toolbar: the API serves this session no personal data and none of the toolbar's actions.
 */
export default function CorrectionPatientHeader({ onBackToCorrections }: { onBackToCorrections: () => void }) {
    return (
        <Box data-testid="correction-patient-header" sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', px: 2, pt: 2, width: '100%' }}>
            <Button size="small" variant="outlined" startIcon={<ArrowBackIcon fontSize="small" />}
                onClick={onBackToCorrections} data-testid="back-to-corrections">
                <Translate id="hospital.my-corrections.out-of-scope.back" />
            </Button>
            <Typography variant="body2" color="text.secondary">
                <Translate id="hospital.my-corrections.patient-without-identity" />
            </Typography>
        </Box>
    );
}
